/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'basic',
    icon: 'mat_outline:dashboard',
    link: '/dashboard',
  },
  {
    id: 'countryCityStates',
    title: 'Country City States',
    type: 'basic',
    icon: 'mat_outline:outlined_flag',
    link: '/countrycitystates',
  },
  {
    id: 'users',
    title: 'Users',
    type: 'basic',
    icon: 'heroicons_outline:users',
    link: '/users',
  },
  {
    id: 'foodcontentinfo',
    title: 'Food Content Info',
    type: 'basic',
    icon: 'mat_outline:category',
    link: '/foodcontentinfo',
  },
  {
    id: 'category',
    title: 'Category',
    type: 'basic',
    icon: 'mat_outline:category',
    link: '/category',
  },
  {
    id: 'restaurant-ratings-category',
    title: 'Rest. Ratings Category',
    type: 'basic',
    icon: 'mat_outline:category',
    link: '/restaurant-ratings-categories',
  },
  {
    id: 'restaurant',
    title: 'Restaurants',
    type: 'basic',
    icon: 'mat_outline:restaurant',
    link: '/restaurant',
  },
  {
    id: 'cuisine',
    title: 'Cuisines',
    type: 'basic',
    icon: 'cuisine',
    link: '/cuisine',
  },
  {
    id: 'posts',
    title: 'Dishes',
    type: 'basic',
    icon: 'mat_outline:menu_book',
    link: '/posts',
  },
  {
    id: 'bulk-image-upload',
    title: 'Bulk Image Upload - Dishes',
    type: 'basic',
    icon: 'heroicons_outline:upload',
    link: '/bulk-image-upload',
  },
  {
    id: 'bulk-restaurant-image-upload',
    title: 'Bulk Image Upload - Restaurants',
    type: 'basic',
    icon: 'heroicons_outline:cloud-upload',
    link: '/bulk-restaurant-image-upload',
  },
  {
    id: 'claimRestaurants',
    title: 'Restaurant Claims',
    type: 'basic',
    icon: 'mat_outline:attach_money',
    link: '/claimRestaurants',
  },
  {
    id: 'claimedRewards',
    title: 'Goodies Claimed',
    type: 'basic',
    icon: 'heroicons_outline:gift',
    link: '/claimedRewards',
  },
  {
    id: 'helps',
    title: 'Helps',
    type: 'basic',
    icon: 'heroicons_outline:question-mark-circle',
    link: '/helps',
  },
  {
    id: 'postReports',
    title: 'Reports - Dish',
    type: 'basic',
    icon: 'mat_outline:report_gmailerrorred',
    link: '/postReports',
  },
  {
    id: 'restaurantReports',
    title: 'Reports - Restaurants',
    type: 'basic',
    icon: 'mat_outline:report_gmailerrorred',
    link: '/restaurantReports',
  },
  {
    id: 'an',
    title: 'Automatic Notifications',
    type: 'basic',
    icon: 'heroicons_outline:bell',
    link: '/auto-notification',
  },
  {
    id: 'foodallergies',
    title: 'Food Allergies',
    type: 'basic',
    icon: 'mat_outline:coronavirus',
    link: '/foodallergies',
  },
  {
    id: 'prh',
    title: 'Dish reaction hashtags',
    type: 'basic',
    icon: 'heroicons_outline:hashtag',
    link: '/post-reaction-hashtags',
  },
  {
    id: 'psd',
    title: 'Dish searches',
    type: 'basic',
    icon: 'heroicons_outline:document-search',
    link: '/postSearches',
  },
  {
    id: 'fmc',
    title: 'Foodophile Codes',
    type: 'basic',
    icon: 'heroicons_outline:qrcode',
    link: '/fmc',
  },
  {
    id: 'games',
    title: 'Games',
    type: 'collapsable',
    icon: 'mat_outline:videogame_asset',
    children: [
      {
        id: 'games.all',
        title: 'List',
        type: 'basic',
        link: '/games/all',
        icon: 'mat_outline:list',
      },
      {
        id: 'games.features',
        title: 'Features Config',
        type: 'basic',
        link: '/games/features',
        icon: 'mat_outline:settings_applications',
      },
    ],
  },
  {
    id: 'badge-management',
    title: 'Badge Management',
    type: 'collapsable',
    icon: 'heroicons_outline:badge-check',
    children: [
      {
        id: 'badge-management.categories',
        title: 'Badge Categories',
        type: 'basic',
        link: '/badge-categories/all',
        icon: 'heroicons_outline:collection',
      },
      {
        id: 'badge-management.badges',
        title: 'Badges',
        type: 'basic',
        link: '/badges/all',
        icon: 'heroicons_outline:star',
      },
    ],
  },
  {
    id: 'founder-circles',
    title: 'Founder Circles',
    type: 'basic',
    icon: 'heroicons_outline:user-group',
    link: '/founder-circles',
  },
  {
    id: 'email-management',
    title: 'Email Management',
    subtitle: 'Promotional emails',
    type: 'group',
    icon: 'heroicons_outline:mail',
    children: [
      {
        id: 'email-templates',
        title: 'Email Templates',
        type: 'basic',
        icon: 'heroicons_outline:template',
        link: '/email-templates',
      },
      {
        id: 'email-schedules',
        title: 'Email Schedules',
        type: 'basic',
        icon: 'heroicons_outline:calendar',
        link: '/email-schedules',
      },
    ],
  },
  {
    id: 'config',
    title: 'Configurations',
    subtitle: 'Configurations for app',
    type: 'group',
    icon: 'heroicons_outline:home',
    children: [
      {
        id: 'config.goodies',
        title: 'Goodies',
        type: 'basic',
        icon: 'heroicons_outline:gift',
        link: '/config/goodies',
      },
      {
        id: 'config.blacklistwords',
        title: 'Blacklist Words',
        type: 'basic',
        icon: 'mat_outline:block',
        link: '/config/blacklistwords',
      },
      {
        id: 'config.rewards',
        title: 'Rewards',
        type: 'basic',
        icon: 'mat_outline:emoji_events',
        link: '/config/rewards',
      },
      {
        id: 'config.rewardcombos',
        title: 'Reward Combos',
        type: 'basic',
        icon: 'mat_outline:emoji_events',
        link: '/config/rewardcombos',
      },
      {
        id: 'config.reportreasons',
        title: 'Report Reasons - Dish',
        type: 'basic',
        icon: 'mat_outline:report',
        link: '/config/reportreasons',
      },
      {
        id: 'config.restaurantreportreasons',
        title: 'Report Reasons - Restaurant',
        type: 'basic',
        icon: 'mat_outline:report',
        link: '/config/restaurantReportreasons',
      },
      {
        id: 'config.settings',
        title: 'Settings',
        type: 'basic',
        icon: 'heroicons_outline:cog',
        link: '/config/settings',
      },
      {
        id: 'config.updater',
        title: 'Updater',
        type: 'basic',
        icon: 'mat_outline:update',
        link: '/config/updater',
      },
    ],
  },
];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
